import { Box, Typography } from '@mui/material';
import React, { useContext, useMemo } from 'react';

import { GroupContext } from '@/pages/ChargingPile/Monitor/components/PileCtxProvider';

import { PileGroupName } from '../../../../../UI/UI';

const NameWithPath: React.FC = () => {
  const { currentGroup } = useContext(GroupContext);

  const groupName = useMemo(() => {
    if (currentGroup) {
      return currentGroup.name;
    }
    return '';
  }, [currentGroup]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          fontSize: '20px',
          lineHeight: '20px',
        }}
      >
        群組：
      </Typography>
      <PileGroupName fontWeight="bold">{groupName}</PileGroupName>
    </Box>
  );
};

export default NameWithPath;
